export const SEARCH_LISTING_QUERY_KEY = "searchListings";
export const LISTING_DETAILS_QUERY_KEY = "listingDetails";
